<template>
  <div class="cf" :class="{ 'cf--inline': labelPosition === 'inline', 'cf--invalid': invalid }">
    <label v-if="label" class="cf__label" :for="inputId">{{ label }}</label>
    <div class="cf__wrap">
      <i v-if="icon" :class="['cf__icon', icon]"></i>
      <input
        :id="inputId"
        class="cf__control"
        :type="type"
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        :name="noAutofill ? inputId : null"
        :autocomplete="autocompleteValue"
        :readonly="noAutofill && !armed"
        data-lpignore="true"
        data-1p-ignore
        @focus="armed = true"
        @input="$emit('input', $event.target.value)"
      />
    </div>
  </div>
</template>

<script>
let uid = 0
export default {
  name: 'CFInput',
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: [String, Number], default: '' },
    type: { type: String, default: 'text' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    icon: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    invalid: { type: Boolean, default: false },
    labelPosition: { type: String, default: 'top' },
    // Автозаполнение браузера: по умолчанию выключено (поля поиска и форм не должны подхватывать
    // сохранённые логины); для пароля — 'new-password'. На странице входа задаётся явно.
    autocomplete: { type: String, default: '' },
    // Жёсткая защита от автозаполнения (формы с логином и паролем другого человека): поле только для
    // чтения, пока в него не встанет курсор, — браузер не успевает подставить сохранённые данные.
    noAutofill: { type: Boolean, default: false }
  },
  computed: {
    autocompleteValue() {
      if (this.autocomplete) return this.autocomplete
      return this.type === 'password' ? 'new-password' : 'off'
    }
  },
  data() {
    return { inputId: `cf-${++uid}`, armed: false }
  }
}
</script>

<style scoped>
.cf__label {
  display: block;
  font-size: var(--text-xs);
  font-weight: var(--font-weight-semibold);
  color: var(--text-secondary);
  margin-bottom: var(--space-2);
}

.cf__wrap { position: relative; }

.cf__control {
  width: 100%;
  padding: var(--space-4) var(--space-8);
  border-radius: var(--radius-input);
  border: var(--border-width-default) var(--border-style-base) var(--border-default);
  font-size: var(--text-base);
  font-family: inherit;
  background: var(--bg-input);
  color: var(--text-primary);
  transition: border-color var(--duration-fast) var(--ease-base),
              background var(--duration-fast) var(--ease-base),
              box-shadow var(--duration-normal) var(--ease-out);
}

.cf__control:hover:not(:focus):not(:disabled) { border-color: var(--border-strong); }

.cf__control:focus {
  outline: none;
  border-color: var(--border-focus);
  background: var(--bg-surface);
  box-shadow: var(--focus-ring);
}

.cf--invalid .cf__control { border-color: var(--danger); }

.cf__control:disabled { opacity: 0.6; cursor: not-allowed; }

.cf__icon {
  position: absolute;
  left: var(--space-8);
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-tertiary);
  font-size: var(--text-sm);
}
.cf__icon + .cf__control { padding-left: var(--space-20); }

.cf--inline { display: flex; align-items: center; gap: var(--space-6); }
.cf--inline .cf__label { margin-bottom: 0; white-space: nowrap; }
</style>
